import assign from "lodash/assign";
import { type Action, handleActions } from "redux-actions";
import { Actions } from "../actions/actions";

interface IState {
  message?: string
  showError: boolean
  showContainer: boolean
}

const initialState: any = {
  message: null,
  showContainer: false,
  showError: false
};

const reducer = handleActions<IState, any>({
  [Actions.ErrorHandling.ERROR_CONTAINER]: (state: IState, action: Action<string>): any => {
    const s = assign({}, state);

    s.showContainer = true;
    s.message = action.payload;

    return s;
  },
  [Actions.ErrorHandling.ERROR_DISPLAY]: (state: IState, action: Action<string>): any => {
    const s = assign({}, state);

    s.showError = true;
    s.message = action.payload;

    return s;
  },
  [Actions.ErrorHandling.ERROR_HIDE]: (state: IState): any => {
    const s = assign({}, state);

    s.showError = false;
    s.message = null;

    return s;
  }
}, initialState);

export default reducer;
